import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { Sanction } from 'app/shared/models/sanction.model';
import { SanctionService } from 'app/entities/monitoring/actual/sanction/sanction.service';

@Component({
  templateUrl: './update-sanction-match.component.html',
  providers: [SanctionService],
})

/**
 * Dialog component to update sanction match information.
 */
export class UpdateSanctionMatchComponent implements OnInit {
  sanctionMatchForm: FormGroup;
  argSanctionMatchDetailsData: string;
  argId: number;
  entityTypeId: number;
  argEntityType: string;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private sanctionMatchService: SanctionService,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.updateTaskDetailsDataForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.sanctionMatchForm = this.formBuilder.group({
      //generalInfoText: [{ value: "" }],
    });
  }

  // Method to update task values and display in the dialog.
  updateTaskDetailsDataForm(): void {
    this.entityTypeId = this.argId;
    if (this.argSanctionMatchDetailsData) {
      this.sanctionMatchForm.patchValue({
        //generalInfoText: this.argSanctionDetailsData,
      });
    }
  }

  // Method to submit the changes for Task Guide text.
  onSubmit({ value, valid }) {
    this.sanctionMatchForm.disable();
    const sanctionMatchModel = new Sanction();
    //generalInfoModel.entityTypeId = this.entityTypeId;
    //generalInfoModel.generalInfo = value.generalInfoText;
    this.sanctionMatchService.updateSanctionMatchDescription(sanctionMatchModel, this.argEntityType)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(sanctionMatchModel);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
          this.trackingService
            .emitEvent(
            TrackingConstants.GENERAL_INFO_TEXT_UPDATE,
            TrackingConstants.PERFORM_GENERAL_INFO_TEXT_UPDATE,
            TrackingConstants.FAILURE, 0);
          this.callSnackBarService(err);
      }
    );
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.GENERAL_INFO_TEXT_UPDATE_SUCCESS,
      MessageService.GENERAL_INFO_TEXT_UPDATE_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.sanctionMatchForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/sanction/sanctionmatch/updatesanctionmatch/update-sanction-match.component.ts